export function fixBR(text: string): string {
  return text.replace(/<br>/g, ' ');
}
